export default class Model {

	constructor(props = {}) {
		this.__skipFlatParams = [];
		Object.assign(this, props);
	}

	setDefaultValues(defaultValues, props) {

		function enforceProperties(context, structure, props) {

			const structureKeys = Object.keys(structure);
			structureKeys.forEach(key => {

				const structureValue = structure[key];
				const propsValue = props instanceof Object ? props[key] : props;

				context[key] = propsValue;

				if (Array.isArray(structureValue) && !Array.isArray(propsValue)
				|| !Array.isArray(structureValue) && Array.isArray(propsValue)) {
					context[key] = structureValue;
				}

				if (Array.isArray(structureValue) && Array.isArray(propsValue)) {
					context[key] = propsValue;
				}

				if (propsValue === undefined || (structureValue instanceof Object && !(propsValue instanceof Object))) {
					context[key] = structureValue;
				}

				if (!Array.isArray(structureValue) && structureValue instanceof Object && Object.keys(structureValue).length !== 0) {
					context[key] = {};
					enforceProperties(context[key], structureValue, propsValue);
				}
			});
		}

		enforceProperties(this, defaultValues, props)
	}

	skipFlatParams(params) {
		this.__skipFlatParams = params;
	}

	flat(includeNulls = true, includeArray = false) {

		const result = {};
		const keys = Object.keys(this);
		for (let i = 0; i < keys.length; i++) {
			const key = keys[i];
			const value = this[key];

			if (this.__skipFlatParams.indexOf(key) !== -1) {
				result[key] = value;
			}

			if (Array.isArray(value) && !includeArray) {
				continue;
			} else if (value === null && !includeNulls) {
				continue;
			} else if (value instanceof Object && value.id !== undefined) {
				result[key] = value.id;
			} else {
				result[key] = value;
			}
		}

		// Remove default values
		delete result['__skipFlatParams'];
		delete result['created_by'];
		delete result['created_on'];
		delete result['modified_by'];
		delete result['modified_on'];

		return result;
	}
}
